import { Controller } from "@hotwired/stimulus"

// A submit guard for destructive button_to forms.
//
// These used `data: { turbo_confirm: ... }`, which Turbo honoured. Turbo is
// deliberately not in this bundle any more (see app/javascript/application.js),
// so that attribute became inert and "Remove" deleted a record on one click
// with no prompt. This restores the prompt without restoring 106KB of Turbo.
//
// Fails safe: if the controller never connects -- JS disabled, a bundle that
// didn't load -- the form is an ordinary form and still submits. The server is
// the authority on whether the delete is allowed; this only asks first.
export default class extends Controller {
  static values = { message: String }

  check(event) {
    if (!window.confirm(this.messageValue)) {
      event.preventDefault()
    }
  }
}
